import styled from 'styled-components';

import { Body2, colors, spacing } from 'ui/theme';

export const Body2LightNoMargin = styled(Body2)`
  color: ${colors.textSecondary};
  margin: 0;
`;

export const FlexBaseGap = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.base};
`;

export const InlineFlexHalfGap = styled.div`
  align-items: center;
  display: flex;
  gap: ${spacing.half};
`;

export const OptimizeSelectedTrigger = styled.div`
  padding-left: ${spacing.half};
`;
